import { Announced } from "@fluentui/react";
import { useEffect, useState } from "react";
import React from "react";
import { useLocation } from "react-router-dom";

export const AccessibleNavigationAnnouncer = () => {
  const [message, setMessage] = useState("");
  const location = useLocation();

  useEffect(() => {
    // Pathname always has / at the front, get rid of it
    // and take the first part of the path for the name
    const pageName = location.pathname.slice(1).split("/")[0];
    if (pageName) {
      setTimeout(() => setMessage(`Navigated to ${pageName} page.`), 500);
    } else {
      setMessage("");
    }
  }, [location]);

  return <Announced message={message} aria-live="assertive" />;
};
